import { Typography, Link } from '@mui/material';
import { useStyles } from './styles';

function CaptchaTerms() {
  const styles = useStyles();

  return (
    <Typography className={styles.captchaTerms}>
      This site is protected by reCAPTCHA and the Google <br />
      <Link
        className={styles.link}
        href="https://policies.google.com/privacy"
        target="_blank"
      >
        Privacy Policy
      </Link>
      {' and '}
      <Link
        className={styles.link}
        href="https://policies.google.com/terms"
        target="_blank"
      >
        Terms of Service
      </Link>
      {' apply.'}
    </Typography>
  );
}

export default CaptchaTerms;
